import { render, staticRenderFns } from "./ContentInsights.vue?vue&type=template&id=34e66748&scoped=true"
import script from "./ContentInsights.vue?vue&type=script&lang=js"
export * from "./ContentInsights.vue?vue&type=script&lang=js"
import style0 from "./ContentInsights.vue?vue&type=style&index=0&id=34e66748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e66748",
  null
  
)

export default component.exports